import React from 'react';
import { Outlet } from 'react-router-dom';
import '../App.scss';
import SideBar from '../component/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import ToastMessage from '../component/ToastMessage';
import { endImpersonation } from '../store/userSlice';
import ImitationBanner from '../pages/ImitationBanner';

const Private = () => {
  const dispatch = useDispatch();
  const { email, exp } = useSelector((state: any) =>
    state.user.isImpersonating && state.user.userData ? state.user.userData : {}
  );

  React.useEffect(() => {
    if (!exp) return;

    const now = Math.floor(Date.now() / 1000);
    const delay = (exp - now) * 1000;

    if (delay <= 0) {
      ToastMessage({ flag: 'Error', message: 'Token expired.' });
      dispatch(endImpersonation());
      return;
    }

    const timer = setTimeout(() => {
      ToastMessage({ flag: 'Error', message: 'Token expired.' });
      dispatch(endImpersonation());
    }, delay);

    return () => clearTimeout(timer);
  }, [exp, dispatch]);

  return (
    <div>
      {email && exp && <ImitationBanner email={email} expiresAt={exp} />}
      <SideBar />
      <main className="main-layout">
        <Outlet />
      </main>
    </div>
  );
};

export default Private;
